/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ValidationProblemSeverity } from '../models/ValidationProblemSeverity';
import { ValidationRuleMetaData } from './ValidationRuleMetaData';

/**
 * An interface used to provide a severity registry.  A severity registry is responsible for
 * indicating the severity of a particular validation problem.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IValidationSeverityRegistry {
    /**
     * Determine what severity to use when reporting on the given rule.
     * @param {ValidationRuleMetaData} rule
     * @return {ValidationProblemSeverity}
     */
    lookupSeverity(rule : ValidationRuleMetaData) : ValidationProblemSeverity;
}


